import { render, staticRenderFns } from "./MultipleCommentCheckbox.vue?vue&type=template&id=442ddb46"
import script from "./MultipleCommentCheckbox.vue?vue&type=script&lang=ts"
export * from "./MultipleCommentCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports